import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';

import { User } from 'src/app/model/user';
import { Admin } from 'src/app/model/admin';

@Injectable({ providedIn: 'root' })
export class CommonServiceLocal {
  public checkBackURL(url: string): Observable<any> {
    const res = { result: 0, error_code: 0 };
    return of(res);
  }

  public getURL(url: string): Observable<any> {
    const res = {
      "result": 0,
      "error_code": 0,
      "userURL": url,
      "usermfaURL": url
    };
    return of(res);
  }

  public checkAccount(userName: string): Observable<any> {
    const res = {
      "result": 0,
      "error_code": 16
    };
    return of(res);
  }

  public getNotifications(): Observable<any> {
    const res = {
      "result": 0,
      "notifications": [
        {
          "id": "101",
          "titleEN": "Maintainence Notice",
          "descEN": "We are going to have a maintenance on OPS BPS Secure on Sundy, the service will not be available between 2am to 5am",
          "titleFR": "Avis de maintenance",
          "descFR": "Nous allons avoir une maintenance sur OPS BPS Secure dimanche, le service ne sera pas disponible entre 2h et 5h du matin"
        },
        {
          "id": "102",
          "titleEN": "Important News",
          "descEN": "The OPS BPS Secure version 2.3 will be released on Apr 1st!",
          "titleFR": "Nouvelles importantes",
          "descFR": "La version 2.3 d'OPS BPS Secure sortira le 1er avril!"
        }  
      ]
    };
    return of(res);
  }  
}
